(function () {
  var BODY_SCROLL_LOCK_CLASSES = [
    'gallery-locked',
    'overflow-hidden',
    'overflow-hidden-mobile',
    'overflow-hidden-tablet'
  ];

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function hasActiveScrollLockSurface() {
    return Boolean(document.querySelector([
      'cart-drawer.active',
      'cart-notification.active',
      '.image-drawer.open',
      'menu-drawer details[open]',
      'details[open].menu-opening',
      'details-modal[open]',
      'pickup-availability-drawer[open]',
      '.modal[open]'
    ].join(',')));
  }

  function cleanupStaleScrollLocks(force) {
    if (!document.body) return;
    if (!force && hasActiveScrollLockSurface()) return;

    BODY_SCROLL_LOCK_CLASSES.forEach(function (className) {
      document.body.classList.remove(className);
    });

    if (document.body.style.overflow === 'hidden') {
      document.body.style.overflow = '';
    }
  }

  function scheduleScrollLockCleanup(force) {
    window.setTimeout(function () {
      cleanupStaleScrollLocks(force);
    }, 80);
  }

  window.addEventListener('pageshow', function () {
    cleanupStaleScrollLocks();
  });

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape') scheduleScrollLockCleanup();
  });

  document.addEventListener('click', function (event) {
    if (event.target.closest('.drawer__close, .modal__close-button, #CartDrawer-Overlay, #closeImageDrawer, [aria-label^="Close"]')) {
      scheduleScrollLockCleanup();
    }
  }, true);

  document.addEventListener('shopify:section:load', function () {
    cleanupStaleScrollLocks();
  });

  function updateCartCount(count) {
    if (typeof count !== 'number') return;
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
    });
  }

  function getSectionInnerHTML(html, selector) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var element = parsed.querySelector(selector);
    return element ? element.innerHTML : '';
  }

  function refreshCartCount() {
    return fetch(window.routes.cart_url + '.js')
      .then(function (cartResponse) { return cartResponse.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return cart;
      })
      .catch(function () { return null; });
  }

  function parseCartResponse(response) {
    return response.text().then(function (text) {
      var data;

      try {
        data = text ? JSON.parse(text) : {};
      } catch (error) {
        throw new Error('Cart temporarily unavailable');
      }

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Could not add item');
      }

      return data;
    });
  }

  function openCartDrawer(cartDrawer, trigger) {
    if (!cartDrawer) return;

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open(trigger);
    } else {
      cartDrawer.classList.add('animate', 'active');
      cartDrawer.removeAttribute('hidden');
      document.body.classList.add('overflow-hidden');
    }
  }

  function refreshDrawer(cartDrawer, response, trigger) {
    if (!cartDrawer) return refreshCartCount();

    if (response.sections) {
      if (typeof cartDrawer.renderContents === 'function') {
        try {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(response);
          return refreshCartCount();
        } catch (error) {
          console.warn('Cart drawer render failed, opening current drawer instead.', error);
        }
      }

      var drawer = document.querySelector('#CartDrawer');
      if (drawer && response.sections['cart-drawer']) {
        var drawerHTML = getSectionInnerHTML(response.sections['cart-drawer'], '#CartDrawer');
        if (drawerHTML) drawer.innerHTML = drawerHTML;
      }

      var bubble = document.querySelector('#cart-icon-bubble');
      if (bubble && response.sections['cart-icon-bubble']) {
        var bubbleHTML = getSectionInnerHTML(response.sections['cart-icon-bubble'], '#cart-icon-bubble');
        if (bubbleHTML) bubble.innerHTML = bubbleHTML;
      }

      cartDrawer.classList.remove('is-empty');
      var inner = cartDrawer.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
      var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
      if (overlay && typeof cartDrawer.close === 'function') {
        overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
      }
    }

    return refreshCartCount().then(function (cart) {
      openCartDrawer(cartDrawer, trigger);

      return cart;
    });
  }

  function buildItemAddedDetail(item, options, cart) {
    var detail = { item: item };

    if (cart) detail.cart = cart;
    if (options && options.detail) {
      Object.keys(options.detail).forEach(function (key) {
        detail[key] = options.detail[key];
      });
    }

    return detail;
  }

  function add(form, options) {
    options = options || {};
    var formData = form instanceof FormData ? form : new FormData(form);
    var cartDrawer = getCartDrawer();

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map(function (section) { return section.id; })
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(options.trigger || document.activeElement);
      }
    }

    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData
    })
      .then(parseCartResponse)
      .then(function (response) {
        return refreshDrawer(cartDrawer, response, options.trigger).then(function (cart) {
          var detail = buildItemAddedDetail(response, options, cart);

          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: detail }));

          if (window.posthog && typeof window.posthog.capture === 'function') {
            try {
              window.posthog.capture('add_to_cart', {
                product_title: response.product_title || response.title || (response.items && response.items[0] && response.items[0].product_title) || null,
                product_handle: response.handle || (response.items && response.items[0] && response.items[0].handle) || (function () {
                  // Aug 24 2026: /cart/add.js returns `url` (/products/<handle>?variant=), not `handle`,
                  // so product_handle was landing null on every PDP cart. Parse it out as a fallback.
                  try {
                    var u = response.url || (response.items && response.items[0] && response.items[0].url) || '';
                    var m = u.match(/\/products\/([^?#\/]+)/);
                    return m ? m[1] : null;
                  } catch (e) { return null; }
                })(),
                variant_id: response.variant_id || response.id || null,
                price: typeof response.final_price === 'number' ? response.final_price / 100 : (typeof response.price === 'number' ? response.price / 100 : null),
                quantity: response.quantity || 1,
                // Aug 24 2026: which control started the cart. options.trigger is the DOM
                // element, options.source is set by the PDP caller. Both were already being
                // passed in and thrown away, so all SBA carts logged trigger: null while MoMo
                // logged add_form / protocol_cta / drawer_upsell. Mirrors that schema.
                trigger: (function () {
                  try {
                    var id = options.trigger && options.trigger.id;
                    if (id === 'heroAddToCart') return 'hero';
                    if (id === 'stickyAddToCart') return 'sticky_bar';
                    if (id === 'mobileStickyAtc') return 'mobile_sticky';
                    if (options.source === 'sba-pdp') return 'pdp_other';
                    return 'catalog_card';
                  } catch (e) { return null; }
                })()
              });
            } catch (error) { /* analytics must never break checkout */ }
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: options.source || 'sba-cart',
              cartData: cart,
              variantId: response.variant_id || response.id
            });
          }

          return response;
        });
      });
  }

  // Keep the visible header cart count ([data-cart-count]) in sync on EVERY cart
  // mutation, not just add. Dawn's cart.js only re-renders the hidden
  // #cart-icon-bubble, so without this the header count goes stale after a
  // quantity change or line-item removal in the drawer or on the cart page.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var data = event && event.cartData;
      if (data && typeof data.item_count === 'number') {
        updateCartCount(data.item_count);
      } else {
        refreshCartCount();
      }
    });
  }

  window.SBACart = {
    add: add,
    updateCartCount: updateCartCount,
    open: function (trigger) {
      var cartDrawer = getCartDrawer();
      if (!cartDrawer) return;
      openCartDrawer(cartDrawer, trigger);
    }
  };

  // Some surfaces (e.g. the gift card PDP) announce cart changes with a bare
  // 'cart:open' event instead of calling SBACart directly — honor it.
  document.addEventListener('cart:open', function (event) {
    refreshCartCount().then(function () {
      var cartDrawer = getCartDrawer();
      if (cartDrawer) openCartDrawer(cartDrawer, event && event.detail && event.detail.trigger);
    });
  });

  window.SBAScrollLockGuard = {
    cleanup: cleanupStaleScrollLocks
  };
})();
